var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#666666;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "House",
    className: "st0",
    d: "M16.847,8.14L8.857,0.149C8.856,0.148,8.855,0.147,8.854,0.146C8.757,0.048,8.628,0,8.5,0  C8.372,0,8.243,0.048,8.146,0.146C8.145,0.147,8.144,0.148,8.143,0.149L0.153,8.14c-0.194,0.194-0.194,0.513,0,0.707  s0.513,0.194,0.707,0L1,8.707V16c0,0.55,0.45,1,1,1h5v0v-6h3v6v0h5c0.55,0,1-0.45,1-1V8.707l0.14,0.14  c0.194,0.194,0.513,0.194,0.707,0S17.042,8.334,16.847,8.14z M15,16h-4v-6H6v6H2V7.707l6.5-6.5l6.5,6.5V16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.63de5d0962a9afc177835f4d6f756e3d.svg";
export { ForwardRef as ReactComponent };